document.addEventListener('DOMContentLoaded', () => {
  const videoCards = document.querySelectorAll('.video-card');
  const popupOverlay = document.querySelector('.video-popup-overlay');
  const popupContent = document.querySelector('.video-popup-content');
  const closePopupButton = document.querySelector('.video-popup-close');

  videoCards.forEach((card) => {
    card.addEventListener('click', (e) => {
      const isVideoClick = e.target.tagName === 'VIDEO' || e.target.tagName === 'IFRAME' || e.target.tagName === 'IMG';
      const isProductOverlay = e.target.closest('.video-card__product-overlay') !== null;
      const isProductInfo = e.target.closest('.video-card__product-info') !== null;

      if (isVideoClick && !isProductOverlay && !isProductInfo) {
        const iframe = card.querySelector('iframe');
        const video = card.querySelector('video');
        const img = card.querySelector('img');

        popupContent.innerHTML = '';

        if (iframe) {
          const iframeClone = iframe.cloneNode(true);
          popupContent.appendChild(iframeClone);
        } else if (video) {
          const videoClone = video.cloneNode(true);
          videoClone.controls = true;
          popupContent.appendChild(videoClone);
        } else if (img) {
          const imgClone = img.cloneNode(true);
          popupContent.appendChild(imgClone);
        }

        popupOverlay.style.display = 'flex';
      }
    });
  });

  closePopupButton.addEventListener('click', () => {
    popupOverlay.style.display = 'none';
    popupContent.innerHTML = '';
  });

  popupOverlay.addEventListener('click', (e) => {
    if (e.target === popupOverlay) {
      popupOverlay.style.display = 'none';
      popupContent.innerHTML = '';
    }
  });
});
